/*
 * Quick Add support for products on the "recharge" product template.
 *
 * The recharge template outputs the newer variant markup (.variant-wrapper radios,
 * .button--add-to-cart). The Quick Add drawer in application.js only initialises the
 * older markup (.variant-select), so on recharge products nothing in the drawer responded.
 * This file runs after Quick Add injects a product and wires the newer markup up.
 * Products on other templates have no .variant-wrapper and are left untouched.
 */
(function () {
  var lastQuickAddHandle = null;

  // Remember which product's Quick Add button was clicked (used for the subscription link).
  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('.button-quick-add');
    if (button && button.dataset.product) lastQuickAddHandle = button.dataset.product.trim();
  }, true);

  function addSubscriptionLink(form) {
    if (!lastQuickAddHandle) return;
    if (!form.querySelector('.variant-wrapper option[data-subscription="true"]')) return;
    var actions = form.querySelector('.action-wrapper');
    if (!actions || actions.querySelector('.quick-add-subscription-link')) return;
    var link = document.createElement('a');
    link.className = 'quick-add-subscription-link';
    link.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'products/' + encodeURIComponent(lastQuickAddHandle);
    link.innerHTML = 'Subscriptions available<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="M13 6l6 6-6 6"/></svg>';
    actions.appendChild(link);
  }

  function bindAddToCart(form, wrapper) {
    var button = form.querySelector('.button--add-to-cart');
    if (!button || button.dataset.quickAddBound) return;
    button.dataset.quickAddBound = 'true';
    button.addEventListener('click', function (e) {
      e.preventDefault();
      window.getSelectedVariants(wrapper, function (status) {
        if (status[0] === 'available') {
          fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: new FormData(form) })
            .then(function (response) { return response.json(); })
            .then(function () {
              window.closeAllDrawers();
              window.updateCartDrawer();
              window.openCartDrawer();
            })
            .catch(function (error) { console.log(error); });
        } else {
          var error = wrapper.querySelector('.variant-error');
          if (error) {
            error.classList.remove('hidden');
            error.style.display = 'block';
          }
        }
      });
    });
  }

  window.initQuickAddRechargeForm = function (drawerContent) {
    if (!drawerContent) return;
    var form = drawerContent.querySelector('form.product-form');
    if (!form) return;
    var wrapper = form.querySelector('.variant-wrapper');
    if (!wrapper) return;

    // Remove parts that only work on the full product page (Recharge widget, subscribe prompt).
    form.querySelectorAll('recharge-subscription-widget, .shopify-app-block, .subscription-unavailable-options, script')
      .forEach(function (el) { el.remove(); });

    // Unique IDs so the drawer's labels never point at inputs in the main product page form.
    form.querySelectorAll('.variant-wrapper input[id]').forEach(function (input) {
      var label = form.querySelector('label[for="' + input.id + '"]');
      input.id = 'qa-' + input.id;
      if (label) label.setAttribute('for', input.id);
    });

    // These already pick up any .variant-wrapper not yet initialised.
    window.initVariantRadios();
    window.checkVariantAvailability();

    bindAddToCart(form, wrapper);
    addSubscriptionLink(form);
  };

  // application.js (deferred) calls window.initQuickAddQuantity() straight after injecting
  // the product into the drawer, so run our setup from there.
  function install() {
    var original = window.initQuickAddQuantity;
    if (typeof original !== 'function' || original.__quickAddRecharge) return;
    var wrapped = function () {
      var result = original.apply(this, arguments);
      try {
        window.initQuickAddRechargeForm(document.getElementById('drawer-quick-add-content'));
      } catch (error) {
        console.log(error);
      }
      return result;
    };
    wrapped.__quickAddRecharge = true;
    window.initQuickAddQuantity = wrapped;
  }

  // This file is deferred but sits earlier in the page than application.js, so it runs first.
  // DOMContentLoaded fires only after every deferred script has run; 'load' is a fallback.
  if (document.readyState === 'complete') {
    install();
  } else {
    document.addEventListener('DOMContentLoaded', install);
    window.addEventListener('load', install);
  }
})();
